// import { Report191 } from '../../../components/borrowSystem/Report/Report191'
import { ListReportComponent } from "../../../components/borrowSystem/Report/ListReportsComponent";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function ListReportContainer() {
  const titleName = "รายงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <ListReportComponent />
      <Footer />
    </div>
  );
}
